import { StatusPill } from '@/components/ui';

import { contactStatusesOf } from './contactDisplay';

export function ContactStatusPills({
  status,
}: {
  status?: { active?: boolean; doNotContact?: boolean } | null;
}) {
  return (
    <span style={{ display: 'inline-flex', flexWrap: 'wrap', gap: 4 }}>
      {contactStatusesOf(status).map((tone) => (
        <StatusPill key={tone} status={tone} />
      ))}
    </span>
  );
}
